




















import { Input } from 'element-ui'
import { Vue, Prop, Component, Ref } from 'vue-property-decorator'

import Currency from '@/models/currency'

import { currencySymbol } from '@/globalMixin'

@Component({
  components: {
    [Input.name]: Input,
  },
})
export default class CustomInputNumber extends Vue {
  @Prop() size!: string
  @Prop() currencyCode!: Currency
  @Ref('inputRef') readonly inputRef!: HTMLInputElement

  value = ''
  symbol = currencySymbol(this.currencyCode)

  get sizeClass(): string {
    return `el-input--${this.size}`
  }

  handleCustomAmountInput(amount: string): void {
    const moneyRegex = /^(\d+[.,]?(\d{1,2})?)?$/
    if (!moneyRegex.test(amount)) {
      return
    }
    this.value = amount.replace(',', '.')
    this.$emit('input', amount)
  }

  handleCustomAmountChange(amount: string): void {
    const roundedAmount = parseFloat(
      (amount === '' ? '0.00' : amount).replace(',', '.'),
    ).toFixed(2)
    this.value = roundedAmount
    this.$emit('change', roundedAmount)
  }
}
